module.exports = __webpack_public_path__ + "static/media/Loan2.e2aae592.svg";